import { render, staticRenderFns } from "./PageHeaderCounts.vue?vue&type=template&id=b9dd4dfc&scoped=true&"
import script from "./PageHeaderCounts.vue?vue&type=script&lang=js&"
export * from "./PageHeaderCounts.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderCounts.vue?vue&type=style&index=0&id=b9dd4dfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dd4dfc",
  null
  
)

export default component.exports